import "core-js/modules/es.array.reduce.js";
import { mixin as pluginMinx } from '@/plugin/index.min.js';
import SortPanel from '@/core/work-components/we-sort-panel';
import LocalPagerPlugin from './plugins/LocalPagerPlugin';
import EmapPlugin from './plugins/emap-plugin'; // import PagerPlugin from './plugins/PagerPlugin'

import FetchDataPlugin from './plugins/FetchDataPlugin';
import tableOpts from './tableOpts';
import ActionColumn from './ActionColumn'; // 默认排序组件

const DEFAULT_SORT_PANEL_PARAMS = {
  col: 3
};
export default {
  name: 'WeDataTable',
  components: {
    ActionColumn,
    SortPanel
  },
  mixins: [pluginMinx],
  LocalPagerPlugin,
  EmapPlugin,
  FetchDataPlugin,
  props: {
    /**
     * 待渲染数据，若使用 fetch-data 插件可不设置此属性
     */
    data: {
      type: [Array, Object],
      default: () => [],
      required: false
    },

    /**
     * 待渲染表格列，若使用 fetch-meta 插件可不设置此属性
     */
    columns: {
      type: Array,
      required: false
    },

    /**
     * 是否展示分页
     */
    showPager: {
      type: Boolean,
      default: false
    },

    /**
     * 默认的分页配置
     */
    pagerOptions: {
      type: Object,

      default() {
        return {
          small: false,
          layout: 'prev, pager, next, jumper, ->, total',
          pageSizes: [10, 20, 50, 100],
          hideOnSinglePage: false
        };
      }

    },

    /**
     * 是否显示多选列
     */
    selection: {
      type: Boolean,
      default: false
    },

    /**
     * 仅对 type=selection 的列有效，类型为 Function，Function 的返回值用来决定这一行的 CheckBox 是否可以勾选：Function(row, index)
     */
    selectable: {
      type: Function
    },

    /**
     * 仅对 type=selection 的列有效，类型为 Boolean，为 true 则会在数据更新之后保留之前选中的数据（需指定 row-key
     */
    reserveSelection: {
      type: Boolean,
      default: false
    },

    /**
     * 操作列定义，默认为展示第一列的按钮功能，
     * 如 [{ label: '编辑', action: (row) => { console.log(row) }}]
     */
    actions: {
      type: [Array, Function],
      default: null
    },

    /**
     * action 显示在左边还是右边 (left / right)
     */
    actionPosition: {
      type: String,
      default: 'left'
    },

    /**
     * 指定操作列宽度
     */
    actionWidth: {
      type: Number,
      default: 100
    },

    /**
     * 是否显示表格右侧的[自定义列]按钮
     */
    canSort: {
      type: Boolean,
      default: true
    },

    /**
     * 指定自定义列组件的属性，具体配置可参考 @wed-pro/we-sort-panel 组件文档
     */
    sortPanel: {
      type: Object
    },

    /**
     * 表格列创建之后自动加载数据，当配置为远程加载的方式时生效
     */
    autoLoad: {
      type: Boolean,
      default: true
    },

    /**
     * 列表过滤条件，指定需要过滤的列及待选条件。eg:
     * {
     *   colName1: [{ text: '条件1', value: 'id1' }, { text: '条件2', value: 'id2' }],
     *   colName2: [{ text: '条件1', value: 'id3' }, { text: '条件2', value: 'id4' }]
     * }
     */
    filters: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    skeletonLoading: true,
    loading: false,
    renderCols: [],
    loadedData: null,
    currentPage: 1,
    // 当前页码
    pageSize: 10,
    // 每页显示条目个数,
    sortedCols: [],
    // 已排序列表
    sortParams: {},
    // 排序参数
    filterParams: {} // 过滤参数

  }),
  computed: {
    headerRowStyle() {
      return {
        width: '100%'
      };
    },

    options() {
      // 允许插件对默认和传入的 props 进行预处理
      const propKeys = this.$options._propKeys;
      const propsData = propKeys.reduce((ret, item) => ({ ...ret,
        [item]: this[item]
      }), {});
      return this.$applyPluginsWaterfall('props', propsData);
    },

    formatedPagerData() {
      const {
        loadedData,
        currentPage = 1,
        pageSize
      } = this; // TODO: 这个地方插件的返回值应该与入参一致。不过目前暂时没有多个分页插件同时使用的情况

      let pagerData = this.$applyPluginsWaterfall('format-page', {
        currentPage,
        pageSize
      }, loadedData);
      return pagerData || 0;
    },

    formatedData() {
      const {
        loadedData
      } = this;
      return this.$applyPluginsWaterfall('format-data', loadedData) || [];
    },

    tableProps() {
      // 自定义传入表格组件的属性
      const ret = this.$applyPluginsWaterfall('table-options', { ...tableOpts,
        ...(this.$attrs || {})
      }); // console.warn('props ret', ret)

      return ret;
    },

    tableColumns() {
      const {
        sortedCols,
        renderCols
      } = this;
      if (!renderCols) return [];
      const renderColMap = renderCols.reduce((ret, item) => ({ ...ret,
        [item.prop]: item
      }), {});
      return sortedCols.filter(item => item.show).map(({
        name
      }) => renderColMap[name]);
    },

    sortPanelOptions() {
      return { ...DEFAULT_SORT_PANEL_PARAMS,
        ...(this.sortPanel || {})
      };
    }

  },
  watch: {
    data() {
      this.reload();
    }

  },

  async created() {
    this.$applyPlugins('init');
    this.loading = true;
    await this.fetchColumns();

    if (this.autoLoad) {
      await this.fetchData();
    }

    this.loading = false;
    /**
     * 表格数据初始化完成事件，每个组件创建后只会触发一次
     */

    this.$emit('inited', this);
  },

  methods: {
    /**
     * 重新加载数据
     * @vuese
     * @param {Object} query 查询的附加参数
     */
    reload(query) {
      return this.fetchData(query);
    },

    /**
     * 用于多选表格，清空用户的选择
     * @vuese
     */
    clearSelection() {
      this.$refs.table.clearSelection();
    },

    onPageChange(currentPage) {
      this.currentPage = currentPage;
      this.fetchData({
        pageNumber: currentPage,
        pageSize: this.pageSize
      });
    },

    onPageSizeChange(pageSize) {
      this.currentPage = 1;
      this.pageSize = pageSize;
      this.fetchData({
        pageNumber: 1,
        pageSize
      });
    },

    async fetchColumns() {
      // 先从属性中获取列定义
      const {
        columns = []
      } = this.options;
      this.renderCols = await this.$applyPluginsAsyncWaterfall('fetch-meta', columns);
      if (!this.renderCols) return [];
      this.sortedCols = this.renderCols.map(item => ({
        name: item.prop,
        label: item.label,
        show: true
      }));
    },

    async fetchData(query = {}) {
      const {
        currentPage,
        pageSize
      } = this;
      const {
        data = null
      } = this.options;
      this.loading = true;
      const result = await this.$applyPluginsAsyncWaterfall('fetch-data', data, query);
      this.dispathEvent('data-loaded', result);
      this.loading = false;
      this.loadedData = result;
      const formatedPage = this.$applyPluginsWaterfall('format-page', {
        currentPage,
        pageSize
      }, result);
      this.currentPage = formatedPage.pageNumber;
      this.pageSize = formatedPage.pageSize;
    },

    renderCell(row, col) {
      let value = row[col.prop]; // 自定义单元格渲染方法

      value = this.$applyPluginsWaterfall('cell-render', value, row, col);
      return value;
    },

    dispathEvent(name, e) {
      /**
       * 支持的事件列表(select, select-all, selection-change, row-click, sort-change, filter-change, expand-change)
       */
      this.$emit(name, e);
    },

    /**
     * 获取已排序的列定义
     * @vuese
     */
    getSortedCols() {
      return this.sortedCols.map(item => ({ ...item
      }));
    },

    /**
     * 点击列头的排序按钮触发此处理
     */
    onSortChange(e) {
      const {
        prop,
        order
      } = e;
      this.sortParams = order !== null ? Object.freeze({
        [prop]: order
      }) : Object.freeze({});
      this.reload();
      this.dispathEvent('sort-change', e);
    },

    /**
     * 执行列头的过滤功能触发此处理
     */
    onFilterChange(e) {
      this.filterParams = this.filterParams || {};
      this.filterParams = { ...this.filterParams,
        ...e
      };
      this.reload();
      this.dispathEvent('filter-change', e);
    }

  }
};